import { DESTINATION_CATEGORIES, DIRECTORY_TABS } from '@components/common/constants';
import { IDestinationDef } from '@stores/destinationDefsList';
import { ISourceDefinition } from '@stores/sourceDefinitionsList';
import { IUserStore } from '@stores/user';
import SourceFactory from '@components/sources/sourceFactory';

export const prettyPrintDestinationCategory = (destinationDef: IDestinationDef) => {
  if (destinationDef.isPopular) {
    return 'Popular';
  }
  return destinationDef.category === DESTINATION_CATEGORIES.WAREHOUSE ? 'Warehouse' : 'Cloud';
};

export const prettyPrintSourceCategory = (
  sourceDef: Pick<ISourceDefinition, 'isPopular' | 'category'>,
) => {
  if (sourceDef.isPopular) {
    return 'Popular';
  }
  const instance = SourceFactory(sourceDef.category);
  if (instance.isPartOf(DIRECTORY_TABS.CLOUD_EXTRACT)) {
    return 'Cloud Extract';
  }
  if (instance.isPartOf(DIRECTORY_TABS.WAREHOUSE_ACTIONS)) {
    return 'Reverse ETL';
  }
  return 'Event Stream';
};

export const prettyPrintUserRole = (userStore: IUserStore) => {
  if (userStore.isTeamsAdmin) {
    return 'Admin';
  }
  return userStore.isAdmin ? 'Read write' : 'Read only';
};
